<template lang='pug'>
  i.svg-icon.svg-icon-agree
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M50,4.8L14,17.7V50c0,25.8,14.4,35.5,36,45.2C71.6,85.5,86,75.8,86,50V17.7C86,17.7,50,4.8,50,4.8L50,4.8z M44,66.9L26,50 l9-8.5l9.3,8.7l19.5-18.4l8.7,8.2L44,66.9z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>